import { Card, CardMedia, Checkbox, Divider, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import config from "src/config";
import AddEditFileModal from "src/pages/AddEditFile.modal";
import TaskIcon from '@mui/icons-material/Task';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { deleteFile } from "src/services/file.service";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import VerifiedIcon from '@mui/icons-material/Verified';

const WordImg = require('./../../assets/fileIcons/word.png');
const ExcelImg = require('./../../assets/fileIcons/excel.png');
const PowerpointImg = require('./../../assets/fileIcons/powerpoint.png');
const PdfImg = require('./../../assets/fileIcons/pdf.png');
const ImageImg = require('./../../assets/fileIcons/image.png');
const AudioImg = require('./../../assets/fileIcons/audio.png');
const VideoImg = require('./../../assets/fileIcons/video.png');
// const ArchiveImg = require('./../../assets/fileIcons/archive.jpeg');
const NoteImg = require('./../../assets/fileIcons/note.png');
const CadImg = require('./../../assets/fileIcons/cad.png');
const DesignImg = require('./../../assets/fileIcons/design.png');
const TextImg = require('./../../assets/fileIcons/text.png');
const CodeImg = require('./../../assets/fileIcons/code.png');
const FileImg = require('./../../assets/fileIcons/file.png');

import { fData } from "src/utils/formatNumber";
import { editFile, getDownloadLink, viewFile } from "src/services/storage.service";
import { duplicateFile } from "src/services/file.service";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import Swal from "sweetalert2";
import FileAuditLogModal from "../file-audit-log/FileAuditLog.modal";
import { formatDate } from "src/methods/common.methods";
import constants from "../constants/common";
import containerMethods from "src/methods/container.methods";
import FileShareModal from "./FileShare.modal";

const fileIcon = {
	'docx': WordImg,
	'doc': WordImg,
	'word': WordImg,
	'xlsx': ExcelImg,
	'xls': ExcelImg,
	'excel': ExcelImg,
	'pptx': PowerpointImg,
	'ppt': PowerpointImg,
	'powerpoint': PowerpointImg,
	'pdf': PdfImg,
	'png': ImageImg,
	'jpg': ImageImg,
	'jpeg': ImageImg,
	'bmp': ImageImg,
	'gif': ImageImg,
	'image': ImageImg,
	'mp3': AudioImg,
	'audio': AudioImg,
	'mp4': VideoImg,
	'video': VideoImg,
	// 'archive': ArchiveImg,
	'note': NoteImg,
	'cad': CadImg,
	'design': DesignImg,
	'txt': TextImg,
	'text': TextImg,
	'ipynb': CodeImg,
	'code': CodeImg,
	// 'file': FileImg
}

const flags = constants.flags;

class FileCard extends React.Component {


	constructor(props) {
		super(props);
		this.state = {
			fileEditModal: false
		}
	}

	goToFileLocation = async (file) => {
		if (file.service == config.FILE_SERVICES.DROPBOX) {
			const response = await viewFile(file.connected_service, file._id);
			if (response.error) {
				alert('Error viewing file location. Please try again later. Check connection status with Dropbox');
				return;
			}
			let url = response.file.preview_link;
			url = url.split('/').slice(0, -1).join('/');
			window.open(url, '_blank');
		} else if (file.service == config.FILE_SERVICES.ONEDRIVE) {
			let url = file.external_details.webUrl;
			url = url.split('/').slice(0, -1).join('/');
			window.open(url, '_blank');
		} else if (file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
			let url = "https://drive.google.com/drive/folders/" + file.external_details.parents[0];
			window.open(url, '_blank');
		}
	}

	viewFile = async (file) => {
		if (file.service == config.FILE_SERVICES.DROPBOX) {
			const response = await viewFile(file.connected_service, file._id);
			const url = response.file.preview_link;
    		window.open(url, '_blank');
		} else if (file.service == config.FILE_SERVICES.ONEDRIVE) {
			window.open(file.external_details.webUrl, '_blank');
		} else if (file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
			const response = await viewFile(file.connected_service, file._id);
			const url = response.file;
    		window.open(url, '_blank');
		} else if (file.service == config.FILE_SERVICES.NEXTCLOUD) {
			const response = await viewFile(file.connected_service, file._id);
			if (response.error) {
				alert('Error viewing file. Please try again later. Check connection status with Nextcloud');
				return;
			}
			const url = response.file;
			window.open(url, '_blank');
		}
	}
	
	editFile = async (file) => {
		if (file.service == config.FILE_SERVICES.NEXTCLOUD || file.service == config.FILE_SERVICES.ONEDRIVE || file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
			const response = await editFile(file.connected_service, file._id);
			if (response.error) {
				alert('Error editing file. Please try again later. Check connection status with Nextcloud');
				return;
			}
			const url = response.file;
			window.open(url, '_blank');
		} else if (file.type == 'excalidraw') {
			// do nothing
		} else {
			alert('File editing not supported for this service');
		}
	}

	getFileInfo = async (file) => {
		this.setState({ fileEditModal: true });
	}

	handleDelete = async (file) => {
		if (!file) {
			return;
		}

		// confirm swal
		let c = await Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#aaa',
			confirmButtonText: 'Yes, delete it!'
		});

		if (c.isConfirmed) {
			// Call the delete API or perform delete action
			let response = await deleteFile(file._id);
			// Handle response
			if (response.error) {
				Swal.fire({
					title: 'Error!',
					text: response.error,
					icon: 'error',
					confirmButtonText: 'Ok'
				});
				return;
			}
			this?.props?.onReload();
			Swal.fire({
				title: 'Deleted!',
				text: 'Your note has been deleted.',
				icon: 'success',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true
			});
		}
	}

	duplicateFile = async (file) => {
		let response = await duplicateFile(file._id);
		if (response.error) {
			Swal.fire({
				title: 'Error!',
				text: response.error,
				icon: 'error',
				confirmButtonText: 'Ok'
			});
			return;
		}
		this?.props?.onReload();
		Swal.fire({
			title: 'Duplicated!',
			text: 'Your file has been duplicated.',
			icon: 'success',
			showConfirmButton: false,
			timer: 2000,
			timerProgressBar: true
		});
	}
	
	downloadFile = async (file) => {
		let response = await getDownloadLink(file.connected_service, file._id);
		if (response.error) {
			console.log('Error getting download link', response.error);
			alert('Error downloading file ' + file.name + '. Please try again later. Check connection status');
			return;
		}
		window.open(response.download_link, '_blank');
	}

	menu = () => {
		return (
			<Menu
				id="simple-menu"
				anchorEl={this.state.anchorEl}
				open={Boolean(this.state.anchorEl)}
				onClose={() => this.setState({anchorEl: null})}
				anchorReference="anchorPosition"
				anchorPosition={{ top: this.state.clickY, left: this.state.clickX }}
			>
				{(this.props?.file?.connected_service ? (
					<>
					<MenuItem onClick={() => {
						this.duplicateFile(this.props.file)
						this.setState({anchorEl: null})
					}}>
						<ListItemIcon>
							<ContentCopyIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>
							Duplicate
						</ListItemText>
					</MenuItem>
					<MenuItem onClick={() => {
						this.downloadFile(this.props.file)
						this.setState({anchorEl: null})
					}}>
						<ListItemIcon>
							<DownloadIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>
							Download
						</ListItemText>
					</MenuItem>
					<FileAuditLogModal
						file={this.props.file}
						onClose={() => this.setState({anchorEl: null})}
					/>
					</>
				) : null)}
				{/* If file owner, then show share */}
				{(this.props?.file?.is_owner) ? (
					<FileShareModal
						file={this.props.file}
						onClose={() => this.setState({anchorEl: null})}
					/>
				) : null}
				<MenuItem onClick={() => {
					this.setState({anchorEl: null})
					this.props?.onSelect(this.props.file);
				}}>
					<ListItemIcon>
						<TaskIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>
						{(this.props?.selected) ? 'Unselect' : 'Select'}
					</ListItemText>
				</MenuItem>
				<Divider />
				<MenuItem color="error"
					onClick={() => {
						this.handleDelete(this.props.file)
						this.setState({anchorEl: null})
					}}
				>
					<ListItemIcon>
						<DeleteForeverIcon fontSize="small" color="error" />
					</ListItemIcon>
					<ListItemText color="error">
						Delete
					</ListItemText>
				</MenuItem>
			</Menu>
		)
	}

	// card header title
	cardHeaderTitle = (file) => {
		let show_selection = this.props?.showSelection;
		const showingName = file.suggested_name ? file.suggested_name : file.name;
		const showingNameWithoutExt = showingName.replace(/\.[^/.]+$/, "");
		const popoverTitle = file.suggested_name ? file.suggested_name : file.name;
		return (
			<Tooltip title={popoverTitle} arrow>
				{(show_selection) ? (
					<Checkbox
						checked={this.props?.selected}
						onChange={() => this.props?.onSelect(file)}
					/>
				) : null}
				{showingNameWithoutExt}
			</Tooltip>
		)
	}

	getFileIcon = (file) => {
		if (file.icon && file.icon != '' && file.icon in fileIcon) {
			return fileIcon[file.icon];
		} else if (file.extension && file.extension in fileIcon) {
			return fileIcon[file.extension];
		} else if (file.sub_category && file.sub_category in fileIcon) {
			return fileIcon[file.sub_category];
		} else {
			return FileImg;
		}
	}

	render() {
		let file = this.props.file;

		return (
			<>
			<Card variant="outlined"
				sx={{
					display: 'flex', flexDirection: 'column', padding: '8px',
					opacity: ((file.inactive_age && file.inactive_age > 365) ? (0.25) : ((file.inactive_age && file.inactive_age > 90) ? (0.5) : 1))
				}}
				onContextMenu={(e) => {
					e.preventDefault();
					this.setState({
						anchorEl: e.currentTarget,
						clickX: e.clientX,
						clickY: e.clientY
					});
				}}
				onDoubleClick={() => {

					if (file.type === 'excalidraw') {
						this.props.navigate('/integrations/excalidraw/app?fileId=' + file._id);
						return;
					}

					if (file.service == config.FILE_SERVICES.NEXTCLOUD || file.service == config.FILE_SERVICES.ONEDRIVE || file.service == config.FILE_SERVICES.GOOGLEDRIVE) {
						this.editFile(file)
					} else {
						this.viewFile(file);
					}
				}}
			>
				{this.menu()}

				<Stack direction="row" alignItems="center" justifyContent="space-between" >
					<Stack direction="row" alignItems="center" spacing={1} flex={1} minWidth={0} width={'100%'}>
						<CardMedia
							sx={{ height: 16, width: 16, mr: 1, flexShrink: 0, borderRadius:"6px", opacity:0.5 }}
							component="img"
							image={this.getFileIcon(file)}
							alt={file.name}
						/>

						<Typography
							variant="body1"
							color="textPrimary" 
							noWrap
							sx={styles?.fileNameStyles}
						>
							{this.cardHeaderTitle(file)}
						</Typography>
					</Stack>

					<Stack direction="row" spacing={1} sx={{ alignItems: 'center', justifyContent: 'flex-end' }}>
						{file.flags?.map((flag, idx) => {
							const flag_data = flags.find(f => f.value === flag);
							if (flag_data?.icon) return flag_data.icon;
							return null;
						})}

						{(file.organizing_status === 'pending') ? (
							<Tooltip title="Organizing in progress">
								<HourglassEmptyIcon fontSize="small" style={{ color: 'lightgray' }} />
							</Tooltip>
						) : null}
						{(file.organizing_status === 'processing') ? (
							<Tooltip title="Organizing in progress">
								<RotateRightIcon fontSize="small" style={{ color: 'lightgray' }} />
							</Tooltip>
						) : null}
						{(file.organizing_status === 'completed' && file.organizing_status_updated_at && (new Date() - new Date(file.organizing_status_updated_at)) < (1000 * 60 * 60)) ? (
							<Tooltip title="Organizing completed">
								<VerifiedIcon fontSize="small" style={{ color: 'lightgray' }} />
							</Tooltip>
						) : null}

						{(file?.is_shared_outside_company) ? (
							<Tooltip title="Shared outside company">
								<PeopleOutlinedIcon fontSize="small" style={{ color: 'lightgray' }} />
							</Tooltip>
						) : null}
					</Stack>
				</Stack>



				<Stack direction="row" justifyContent="space-between" alignItems="flex-end">
					<Stack direction="row" alignItems="center">
						<Tooltip title="Modified">
							<Typography variant="body2" color="textSecondary" component="div" style={{ fontSize: 13, opacity: 0.7 }}>
								{formatDate(file?.latest_modified)}
							</Typography>
						</Tooltip>
					</Stack>
					<Stack direction="row" alignItems="center">
						<Tooltip title="Size">
							<Typography variant="body2" color="textSecondary" component="div" style={{ fontSize: 13, opacity: 0.5 }}>
								{fData(file.size)}
							</Typography>
						</Tooltip>
					</Stack>
					
					{(this.props.minimal) ? null : (
						<IconButton
							onClick={(e) => {
								e.preventDefault();
								this.setState({
									anchorEl: e.currentTarget,
									clickX: e.clientX,
									clickY: e.clientY,
								});
							}}
							sx={{ p: 0 }}
						>
							<MoreHorizOutlinedIcon />
						</IconButton>
					)}
				</Stack>

				{(this.props.minimal) ? null : (
					<Stack direction="row">
						{(!file?.is_owner) ? (
							<Stack direction="row" alignItems="center" sx={{ opacity: 0.3, minWidth: 0, flex: 1, flexGrow: 1 }}>
								<ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3, flexShrink: 0 }} />
								<Typography
									variant="body2"
									color="textSecondary"
									component="div"
									noWrap
									sx={{
										fontSize: 13,
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										minWidth: 0,
									}}
								>
									{file?.owner?.name ? (file?.owner?.name + ' (' + file?.owner?.username + ')') : file?.owner?.username}
								</Typography>
							</Stack>
						) : (
							<Stack direction="row" alignItems="center" sx={{ opacity: 0.3, minWidth: 0, flex: 1, flexGrow: 1 }}>
								<ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3, flexShrink: 0 }} />
								<Typography
									variant="body2"
									color="textSecondary"
									component="div"
									noWrap
									sx={{
										fontSize: 13,
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										minWidth: 0,
									}}
								>
									{'You'}
								</Typography>
							</Stack>
						)}
						
						{(file?.containers?.[0]?.name) ? (
							<Stack direction="row" alignItems="center" sx={{ opacity: 0.7, minWidth: 0, flexGrow: 0, flexShrink: 0, maxWidth: 150 }}>
								{containerMethods.getContainerIcon({}, { color: 'gray', fontSize: '15px' })}
								<Typography
									variant="body2"
									color="textSecondary"
									component="div"
									noWrap
									style={{
										marginLeft: '4px',
										fontSize: 13,
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										minWidth: 0,
									}}>
									{file?.containers?.[0]?.name}
								</Typography>
							</Stack>
						) : null}
						

						<Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ opacity: 0.7, flexShrink: 0 }}>
							<IconButton
								onClick={() => this.getFileInfo(file)}
								sx={{ p: 0 }}
							>
								<KeyboardArrowDownIcon />
							</IconButton>
						</Stack>
					</Stack>
				)}
			</Card>
			{(this.state.fileEditModal) ? (
				<AddEditFileModal
					open={this.state.fileEditModal}
					file={file}
					onClose={() => this.setState({fileEditModal: false})}
					onSave={() => {
						this.setState({fileEditModal: false})
						this.props.onReload();
					}}
				/>
			) : null}
			</>
		)
	}
}


// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();
    return <FileCard {...props} navigate={navigate} params={params} />;
}

const fileCardInstance = new FileCard();

export { fileCardInstance };

const styles={
	iconStyles:{
		opacity:0.5,
		width: '20px',
		height: 'auto'
	},
	fileNameStyles:{
		flex: 1,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	labelStyles:{
		fontSize: "0.75rem",
		fontWeight: 500,
	}
}